import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface GalleryLayoutStylesProps {
  aspectRatio: number;
  hasFixedMainMedia: boolean;
}

export const useGalleryLayoutStyles = makeStyles<GalleryLayoutStylesProps>()(
  (theme: Theme, { aspectRatio, hasFixedMainMedia }) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      overflow: 'hidden',

      [theme.breakpoints.down('lg')]: {
        height: 'auto',
      },
    },
    mainMediaBox: {
      position: 'relative',
      width: '100%',
      flex: '1 1 auto',
      minHeight: 0,

      [theme.breakpoints.only('xs')]: {
        flex: '0 0 auto',
        aspectRatio: `${aspectRatio}`,
      },

      [theme.breakpoints.between('sm', 'lg')]: {
        display: 'none',
      },

      ...(hasFixedMainMedia && {
        [theme.breakpoints.up('lg')]: {
          flex: '0 0 auto',
          aspectRatio: `${aspectRatio}`,
        },
      }),
    },
    mediaDotsIndicator: {
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
  }),
);
